import { GenIcon } from '../helpers/IconBase.es.js';

const MobileAndDesktopOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 25 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.123 4.75C11.123 4.05964 11.6827 3.5 12.373 3.5H19.873C20.5634 3.5 21.123 4.05964 21.123 4.75V19.25C21.123 19.9404 20.5634 20.5 19.873 20.5H12.373C11.6827 20.5 11.123 19.9404 11.123 19.25V4.75ZM12.373 2C10.8542 2 9.62302 3.23122 9.62302 4.75V19.25C9.62302 20.7688 10.8542 22 12.373 22H19.873C21.3918 22 22.623 20.7688 22.623 19.25V4.75C22.623 3.23122 21.3918 2 19.873 2H12.373ZM4.4165 4.73926C4.4165 4.60119 4.52843 4.48926 4.6665 4.48926H8.01433C8.42854 4.48926 8.76433 4.15347 8.76433 3.73926C8.76433 3.32504 8.42854 2.98926 8.01433 2.98926H4.6665C3.70001 2.98926 2.9165 3.77276 2.9165 4.73926V14.9132C2.9165 15.8797 3.70001 16.6632 4.6665 16.6632H8.01433C8.42854 16.6632 8.76433 16.3274 8.76433 15.9132C8.76433 15.499 8.42854 15.1632 8.01433 15.1632H4.6665C4.52843 15.1632 4.4165 15.0512 4.4165 14.9132V4.73926ZM16.1665 17C15.6142 17 15.1665 17.4477 15.1665 18C15.1665 18.5523 15.6142 19 16.1665 19C16.7188 19 17.1665 18.5523 17.1665 18C17.1665 17.4477 16.7188 17 16.1665 17ZM5.40564 18.6411C4.99143 18.6411 4.65564 18.9769 4.65564 19.3911C4.65564 19.8053 4.99143 20.1411 5.40564 20.1411H8.01434C8.42855 20.1411 8.76434 19.8053 8.76434 19.3911C8.76434 18.9769 8.42855 18.6411 8.01434 18.6411H5.40564Z",
          fill: "#1990FF"
        }
      }
    ]
  })(props);
};

export { MobileAndDesktopOutlined };
